import React from "react";
import "./ComingSoon.scss";
import fathomLogo from "../../assets/image/logo/Fathom-Logo.png";

const ComingSoon = () => {
  return (
    <div className="comingsoon-container">
      <div className="comingsoon-content">
        <img
          src={fathomLogo}
          alt="Fathom company logo"
          className="comingsoon-logo"
        />
        <p className="comingsoon-message">
          For optimal functionality and user experience, please access this
          website using a desktop device.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
